import { VocabularyForm } from "../../components/Forms/VocabularyForm";

const NewVocabulary = () => {
  return <VocabularyForm />;
};

export default NewVocabulary;
